import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./scss/index.scss";
import * as React from "react";
import { useIntl } from "react-intl";
import ReactSVG from "react-svg";
import { Overlay } from "../..";
import closeImg from "../../../images/x.svg";

var InfoPopup = function InfoPopup(_ref) {
  var overlay = _ref.overlay;
  var intl = useIntl();
  var _overlay$context$data = overlay.context.data,
      title = _overlay$context$data.title,
      desc = _overlay$context$data.desc,
      image = _overlay$context$data.image;
  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement("div", {
    className: "info-popup"
  }, React.createElement(ReactSVG, {
    path: closeImg,
    onClick: function onClick() {
      return overlay.hide();
    },
    className: "info-popup__close"
  }), image && React.createElement("img", {
    className: "info-popup__image",
    src: image === null || image === void 0 ? void 0 : image.src,
    alt: image === null || image === void 0 ? void 0 : image.alt
  }), title && React.createElement("div", {
    className: "info-popup__title"
  }, title), desc && React.createElement("div", {
    className: "info-popup__desc"
  }, desc), React.createElement("button", {
    className: "info-popup__btn",
    type: "button",
    onClick: function onClick() {
      return overlay.hide();
    }
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Okay",
    "id": "components.OverlayManager.InfoPopup.index.460423030"
  }, "id", "components.OverlayManager.InfoPopup.index.460423030")))));
};

export default InfoPopup;